// Global
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import { useTheme } from 'lib/context/ThemeContext';
import { useRecentlyViewed } from 'lib/utils/useRecentlyViewed';
import { useState } from 'react';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
// Components
import Component from 'src/helpers/Component/Component';
import Headline from 'src/helpers/Headline/Headline';
import LinkWrapper from 'src/helpers/LinkWrapper/LinkWrapper';
import SvgIcon from 'src/helpers/SvgIcon/SvgIcon';

import { RecentlyViewedDocumentsTheme } from './RecentlyViewedDocuments.theme';

export type RecentlyViewedDocumentsProps =
  Feature.EnterpriseWeb.AndersenWindows.Components.Listing.RecentlyViewedDocuments.RecentlyViewedDocuments;
const RecentlyViewedDocuments = (props: RecentlyViewedDocumentsProps) => {
  const { themeData, themeName } = useTheme(RecentlyViewedDocumentsTheme);
  const [showAll, setShowAll] = useState(false);
  const recentlyViewedItems = useRecentlyViewed();
  return (
    <Component variant="lg" dataComponent="listing/recentlyvieweddocuments" {...props}>
      {recentlyViewedItems.recentLinks.length > 0 && (
        <>
          <div className={themeData.classes.headlineBorder}>
            <div className="mt-s flex md:mt-xxs">
              {themeName === 'aw' && (
                <div className="m-xxxs mt-[1px] flex">
                  <SvgIcon icon="orange-triangle" />
                </div>
              )}
              <Headline classes={themeData.classes.headlineClass} {...props} />
            </div>
          </div>

          <div className="col-span-12 border-t border-solid border-gray md:col-span-8">
            <ul className={`flex flex-col`}>
              {recentlyViewedItems.recentLinks.length > 0 &&
                recentlyViewedItems.recentLinks.map(
                  (item: RecentlyViewedDocumentsProps, index: number) => {
                    return (
                      item && (
                        <li key={item.id} className={classNames(!showAll && index > 3 && 'hidden')}>
                          <LinkWrapper
                            field={item}
                            className="flex border-b border-solid border-gray py-s text-body text-darkprimary hover:underline"
                            target="_blank"
                            ariaLabel={{
                              value: item || 'Recently Viewed Items',
                            }}
                          />
                        </li>
                      )
                    );
                  }
                )}
            </ul>
            {recentlyViewedItems.recentLinks.length > 4 && (
              <button
                type="button"
                className="mt-s cursor-pointer border-none bg-transparent p-0 font-sans text-text-link font-heavy underline"
                onClick={() => setShowAll(!showAll)}
              >
                {showAll ? 'View Less' : 'View All'}
              </button>
            )}
          </div>
        </>
      )}
    </Component>
  );
};

export default withDatasourceCheck()<RecentlyViewedDocumentsProps>(RecentlyViewedDocuments);
